import { render } from "./SortTableFiltersComponent.vue?vue&type=template&id=13777418&scoped=true"
import script from "./SortTableFiltersComponent.vue?vue&type=script&lang=js"
export * from "./SortTableFiltersComponent.vue?vue&type=script&lang=js"

import "./SortTableFiltersComponent.vue?vue&type=style&index=0&id=13777418&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13777418"]])

export default __exports__